import * as React from 'react';

/**
 * Can use dom element?
 * @return {boolean}
 */
function canUseDOM() {
  return !!(
    typeof window !== 'undefined'
    && window.document
    && window.document.createElement
  );
}

const useIsomorphicLayoutEffect = canUseDOM()
  ? React.useLayoutEffect
  : React.useEffect;

/**
 * The hook lock the body scroll
 * @param {boolean} lock
 * @param {React.RefObject<HTMLElement>} ref
 * @return {void}
 */
const useLockBodyScroll = (
    lock: boolean = true,
    ref?: React.RefObject<HTMLElement>,
): void => {
  useIsomorphicLayoutEffect(() => {
    if (ref && !ref.current) return;
    const el = ref?.current ?? document.body;
    if (lock) {
      const previousValue = el.style.overflow || 'visible';
      el.style.overflow = 'hidden';
      return () => {
        if (!el) return;
        el.style.overflow = previousValue;
      };
    }
  }, [lock, ref]);
};

export default useLockBodyScroll;
